<template>
  <div class="container">
    <div class="register-wrapper">
      <div class="register-card">
        <el-icon class="back-icon" @click="goToLogin">
          <ArrowLeft/>
        </el-icon>
        <div class="register-header">
          <h2>用户注册</h2>
          <p>欢迎加入智能设备后市场服务云平台</p>
        </div>
        <el-form
            ref="formRef"
            :model="formData"
            :rules="rules"
            class="register-form"
            @submit.prevent="handleSubmit"
        >
          <!-- 手机号 -->
          <el-form-item label="手机号" label-width="6rem" label-position="left" prop="telephone">
            <el-input
                v-model="formData.telephone"
                placeholder="请输入手机号"
                clearable
            />
          </el-form-item>

          <!-- 短信验证码 -->
          <el-form-item label="验证码" label-width="6rem" label-position="left" prop="verifyCode">
            <div class="verify-code-row">
              <el-input
                  v-model="formData.verifyCode"
                  placeholder="请输入验证码"
                  maxlength="6"
                  clearable
                  class="verify-code-input"
              />
              <VerifyCodeButton :telephone="formData.telephone"/>
            </div>
          </el-form-item>

          <!-- 密码 -->
          <el-form-item label="密码" label-width="6rem" label-position="left" prop="password">
            <el-input
                v-model="formData.password"
                type="password"
                placeholder="请输入密码"
                show-password
                clearable
            >
            </el-input>
          </el-form-item>

          <!-- 确认密码 -->
          <el-form-item label="确认密码" label-width="6rem" label-position="left" prop="confirmPassword">
            <el-input
                v-model="formData.confirmPassword"
                type="password"
                placeholder="请确认密码"
                show-password
                clearable
            >
            </el-input>
          </el-form-item>

          <!-- 协议同意 -->
          <AgreementCheckbox v-model="formData.agreed"/>

          <!-- 注册按钮 -->
          <el-form-item>
            <el-button
                type="primary"
                class="register-btn"
                :disabled="!formData.agreed"
                @click="handleSubmit"
            >
              立即注册
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  background: linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%);
}

.register-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.5rem 1.25rem;
}

.register-card {
  width: 28rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 2.5rem;
  position: relative;
}

.back-icon {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  font-size: 1.25rem;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
  z-index: 10;
}

.back-icon:hover {
  color: #1890ff;
}

.register-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.register-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1890ff;
  margin: 0 0 0.4rem 0;
}

.register-header p {
  font-size: 0.875rem;
  color: #666;
  margin: 0;
}

.register-form {
  width: 100%;
}

.register-form :deep(.el-form-item) {
  margin-bottom: 1.2rem;
}

.register-form :deep(.el-form-item__label) {
  font-size: 1rem;
  color: #333;
  font-weight: 500;
  line-height: 2.75rem;
  height: 2.75rem;
}

.register-form :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px #d9d9d9 inset;
  border-radius: 8px;
  height: 2.75rem;
  padding: 0.3rem 0.45rem;
}

.register-form :deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #40a9ff inset;
}

.register-form :deep(.el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 1px #1890ff inset;
}

.register-form :deep(.el-input__inner) {
  font-size: 0.9375rem;
  line-height: 1.75rem;
  height: 1.75rem;
}

.register-form :deep(.el-button) {
  font-size: 0.9375rem;
  height: 2.75rem;
  padding: 0.5rem 1.5rem;
}

.password-toggle {
  color: #999;
  transition: color 0.3s;
}

.password-toggle:hover {
  color: #1890ff;
}

/* 验证码输入行 */
.verify-code-row {
  display: flex;
  gap: 0.5rem;
  width: 100%;
}

.verify-code-input {
  flex: 1;
}

/* 注册按钮 */
.register-btn {
  width: 100%;
}

.form-footer {
  text-align: center;
  margin-top: 1.2rem;
  font-size: 0.875rem;
  color: #666;
}

.login-link {
  color: #1890ff;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s;
}

.login-link:hover {
  color: #40a9ff;
  text-decoration: underline;
}
</style>

<script setup>
import {ref, reactive} from 'vue'
import {useRouter} from 'vue-router'
import {ElMessage} from 'element-plus'
import {ArrowLeft} from '@element-plus/icons-vue'
import AgreementCheckbox from '@/components/templates/AgreementCheckbox.vue'
import VerifyCodeButton from '@/components/templates/VerifyCodeButton.vue'
import apiClient from "@/components/plugins/axios";
import {JSEncrypt} from "jsencrypt";

const router = useRouter()
const formRef = ref()
const submitTimer = ref(null)
const isSubmitting = ref(false)

const formData = reactive({
  telephone: '',
  verifyCode: '',
  password: '',
  confirmPassword: '',
  agreed: false
})

// 验证规则
function validateConfirmPassword(rule, value, callback) {
  if (value !== formData.password) {
    callback(new Error('两次输入的密码不一致'))
  } else {
    callback()
  }
}

const rules = reactive({
  telephone: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur'}
  ],
  verifyCode: [
    {required: true, message: '请输入验证码', trigger: 'blur'}
  ],
  password: [
    {required: true, message: '请输入密码', trigger: 'blur'},
    {pattern: /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,16}$/, message: '密码必须为8-16位，且同时包含数字和字母', trigger: 'blur'}
  ],
  confirmPassword: [
    {required: true, message: '请确认密码', trigger: 'blur'},
    {validator: validateConfirmPassword, trigger: 'blur'}
  ]
})

// 提交表单（带防抖）
async function handleSubmit() {
  // 防抖处理：如果正在提交，直接返回
  if (isSubmitting.value) {
    return
  }

  // 清除之前的定时器
  if (submitTimer.value) {
    clearTimeout(submitTimer.value)
  }

  // 设置防抖延迟
  submitTimer.value = setTimeout(async function() {
    if (isSubmitting.value) {
      return
    }
    isSubmitting.value = true

    // 1. 表单验证
    try {
      await formRef.value.validate();
    } catch (error) {
      isSubmitting.value = false
      ElMessage.error({
        message: '请检查表单填写',
        duration: 1000,
      });
      return;
    }

    // 2. 执行注册流程
    try {
      // 获取加密公钥
      const keyRes = await apiClient.get('/api/v1/common/get/pubkey');
      if (!keyRes.data.public_key) {
        throw new Error('获取加密公钥失败，请重试');
      }

      // 加密密码
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(keyRes.data.public_key);
      const encryptedPassword = encrypt.encrypt(formData.password).toString();
      if (!encryptedPassword) {
        throw new Error('密码加密失败，请检查公钥格式');
      }

      // 发送注册请求
      const registerRes = await apiClient.post(
          '/api/v1/client/user/register',
          {
            telephone: formData.telephone,
            password: encryptedPassword,
            verify_code: formData.verifyCode,
          }
      );

      // 处理响应
      if (registerRes.data.code !== 200) {
        throw new Error(registerRes.data.message || `注册失败`);
      }

      const {data} = registerRes.data;
      // 保存用户信息
      localStorage.setItem('access_token', `${data.token_type} ${data.access_token}`);
      localStorage.setItem('refresh_token', data.refresh_token);
      localStorage.setItem('userInfo', JSON.stringify({
        id: data.id,
        telephone: data.telephone,
        gender: data.gender,
        nickname: data.nickname,
        avatar: data.avatar,
        birthday: data.birthday
      }));

      // 触发自定义事件，通知 Header 组件更新用户信息
      window.dispatchEvent(new CustomEvent('auth-change'));

      // 仅在所有操作成功完成后，显示成功提示
      ElMessage.success({
        message: '注册成功！',
        duration: 1000,
      });
      await router.push('/')
    } catch (error) {
      ElMessage.error({
        message: error.message,
        duration: 1000,
      });
    } finally {
      isSubmitting.value = false
    }
  }, 500)
};

// 跳转到登录页面
function goToLogin() {
  router.push('/login')
}
</script>
